/*
 * @Author: Zhouqi
 * @Date: 2025-12-15 11:55:58
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-12-18 15:30:02
 */
import { useCallback, useEffect, useRef, useState } from 'react';

// 创建一个自定义 hook 管理加载状态
export const useImageLoading = () => {
  const beforeImageLoadingRef = useRef(true);
  const afterImageLoadingRef = useRef(true);
  const [compareImagesLoaded, setCompareImagesLoaded] = useState(false);

  // 重置加载状态
  useEffect(() => {
    beforeImageLoadingRef.current = true;
    afterImageLoadingRef.current = true;
    setCompareImagesLoaded(false);
  }, []);

  const handleBeforeImageLoad = useCallback(() => {
    beforeImageLoadingRef.current = false;
    if (!afterImageLoadingRef.current) {
      setCompareImagesLoaded(true);
    }
  }, []);

  const handleAfterImageLoad = useCallback(() => {
    afterImageLoadingRef.current = false;
    if (!beforeImageLoadingRef.current) {
      setCompareImagesLoaded(true);
    }
  }, []);

  return {
    isLoading: !compareImagesLoaded,
    handleBeforeImageLoad,
    handleAfterImageLoad,
  };
};
